var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 111,
    viewBox: "0 0 108 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 6.3094C52.4752 4.88034 55.5248 4.88034 58 6.3094L96.7654 28.6906C99.2406 30.1197 100.765 32.7607 100.765 35.6188V80.3812C100.765 83.2393 99.2406 85.8803 96.7654 87.3094L58 109.691C55.5248 111.12 52.4752 111.12 50 109.691L11.2346 87.3094C8.75942 85.8803 7.23463 83.2393 7.23463 80.3812V35.6188C7.23463 32.7607 8.75942 30.1197 11.2346 28.6906L50 6.3094Z",
    fill: "#F9FAFB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_139_1279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 11.7321C52.8564 10.6603 55.1436 10.6603 57 11.7321L92.5692 32.268C94.4256 33.3397 95.5692 35.3205 95.5692 37.4641V78.5359C95.5692 80.6795 94.4256 82.6603 92.5692 83.732L57 104.268C55.1436 105.34 52.8564 105.34 51 104.268L15.4308 83.732C13.5744 82.6603 12.4308 80.6795 12.4308 78.5359V37.4641C12.4308 35.3205 13.5744 33.3397 15.4308 32.268L51 11.7321Z",
    fill: "url(#paint0_linear_139_1279)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_139_1279)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4142 52.7475C34.6332 51.9665 33.3668 51.9665 32.5858 52.7475L28.7475 56.5858C27.9665 57.3668 27.9665 58.6332 28.7475 59.4142L45.9191 76.5858C46.7002 77.3668 47.9665 77.3668 48.7475 76.5858L79.2525 46.0809C80.0335 45.2998 80.0335 44.0335 79.2525 43.2525L75.4142 39.4142C74.6332 38.6332 73.3668 38.6332 72.5858 39.4142L48.7475 63.2525C47.9665 64.0335 46.7002 64.0335 45.9191 63.2525L35.4142 52.7475Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8783 38.707C73.0498 37.5355 74.9498 37.5355 76.1214 38.707L79.9593 42.5449C81.1309 43.7165 81.1309 45.6165 79.9593 46.7881L49.4544 77.293C48.2829 78.4643 46.3838 78.4643 45.2122 77.293L28.0404 60.1211C26.869 58.9496 26.869 57.0504 28.0404 55.8789L31.8783 52.04C33.0498 50.8685 34.9498 50.8686 36.1214 52.04L46.6263 62.5449C47.0168 62.9354 47.6498 62.9354 48.0404 62.5449L71.8783 38.707Z",
    stroke: "url(#paint1_linear_139_1279)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_139_1279",
    x: 12.4308,
    y: 10.9282,
    width: 83.1384,
    height: 94.1436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_139_1279"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_139_1279",
    x: 26.1618,
    y: 36.8284,
    width: 55.6765,
    height: 48.3431,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_1279"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_1279",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_139_1279",
    x1: 102,
    y1: 106,
    x2: 14.4969,
    y2: 2.7958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0837AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_139_1279",
    x1: 81,
    y1: 78,
    x2: 27,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0837AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.6ddd826f61eee788e7d17997e44748b5.svg";
export { ForwardRef as ReactComponent };